import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import DiferenciaisSection from './components/DiferenciaisSection';
import BeneficiosSection from './components/BeneficiosSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import SeoJsonLd from '@/components/feature/SeoJsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': ['AccountingService', 'LocalBusiness'],
  name: 'RCP Inteligência Contábil & Tributária',
  description:
    'Escritório contábil em Porto Alegre com expertise em auditoria fiscal, planejamento tributário e estratégia fiscal. Combinamos experiência contábil e visão analítica para transformar números em decisões inteligentes.',
  url: siteUrl,
  telephone: '+55-51-99100-3410',
  email: 'contato@rcpinteligencia.com.br',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Porto Alegre',
    addressRegion: 'RS',
    addressCountry: 'BR',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: -30.0346,
    longitude: -51.2177,
  },
  areaServed: {
    '@type': 'State',
    name: 'Rio Grande do Sul',
  },
  priceRange: '$$',
  knowsLanguage: 'pt-BR',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Serviços Contábeis e Tributários',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Planejamento Tributário' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Auditoria Fiscal' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Contabilidade Empresarial' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Assessoria Estratégica' } },
    ],
  },
  sameAs: ['https://instagram.com/inteligenciarcp'],
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'O diagnóstico inicial é gratuito?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sim. A RCP oferece um diagnóstico inicial gratuito e sem compromisso para entender as necessidades da sua empresa e apresentar uma proposta personalizada.',
      },
    },
    {
      '@type': 'Question',
      name: 'Em quanto tempo a RCP entra em contato após a solicitação?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Nosso time entra em contato em até 24 horas úteis após o recebimento da sua solicitação.',
      },
    },
    {
      '@type': 'Question',
      name: 'Quais serviços a RCP Inteligência Contábil oferece?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'A RCP oferece serviços de contabilidade empresarial, planejamento tributário, auditoria fiscal e assessoria estratégica para empresas de todos os portes em Porto Alegre e região.',
      },
    },
    {
      '@type': 'Question',
      name: 'A RCP atende empresas de qual porte?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Atendemos empresas de todos os portes — de MEIs e pequenas empresas a médias e grandes corporações — com soluções contábeis e tributárias personalizadas.',
      },
    },
  ],
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  url: siteUrl,
  name: 'RCP Inteligência Contábil & Tributária Porto Alegre | Contabilidade com Visão de Auditoria',
  description:
    'Escritório contábil em Porto Alegre especializado em planejamento tributário, auditoria fiscal e estratégia contábil com mais de 10 anos de experiência.',
  inLanguage: 'pt-BR',
  isPartOf: {
    '@type': 'WebSite',
    url: siteUrl,
    name: 'RCP Inteligência Contábil & Tributária',
  },
};

export default function HomePage() {
  return (
    <main className="min-h-screen">
      <SeoJsonLd id="ld-local-business" data={localBusinessSchema} />
      <SeoJsonLd id="ld-faq" data={faqSchema} />
      <SeoJsonLd id="ld-webpage" data={webPageSchema} />

      <Navbar />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <DiferenciaisSection />
      <BeneficiosSection />
      <ContactSection />
      <Footer />

      {/* Floating WhatsApp CTA */}
      <div className="fixed bottom-8 right-8 z-50">
        <a
          href="https://wa.me/5551991003410"
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="group flex items-center gap-3 bg-[#c9a84c] hover:bg-[#b8943d] text-[#0f2651] font-semibold text-sm px-5 py-3.5 rounded-full cursor-pointer whitespace-nowrap transition-all duration-200"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-whatsapp-line text-base" />
          </div>
          <span>Diagnóstico Gratuito</span>
          <div className="w-5 h-5 flex items-center justify-center group-hover:translate-x-0.5 transition-transform duration-200">
            <i className="ri-arrow-right-line text-base" />
          </div>
        </a>
      </div>
    </main>
  );
}
